(() => {
  const selectedQuantityOption = (event) => {
    if (!(event.target instanceof Element)) return null;

    const option = event.target.closest(
      'product-form [role="radiogroup"] [role="radio"][aria-checked="true"]'
    );
    return option?.closest('product-form') ? option : null;
  };

  const preventDeselection = (event) => {
    if (!selectedQuantityOption(event)) return;

    event.preventDefault();
    event.stopPropagation();
  };

  document.addEventListener('click', preventDeselection, true);
  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Enter' || event.key === ' ') preventDeselection(event);
    },
    true
  );
})();
